import { resolveImagePath } from "@/utils/imageMap.ts";

export function Footer() {
  const footerBg = resolveImagePath("/images/footer-bg.jpg");

  return (
    <footer className="relative w-full overflow-hidden" style={{ minHeight: "120px" }}>
      <img
        src={footerBg}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="relative z-10 flex flex-col items-center justify-center text-center py-10 px-4">
        <a
          href="mailto:info@merlinaviation.net"
          className="font-body text-[#1e2025] text-base hover:underline mb-1"
        >
          info@merlinaviation.net
        </a>
        <p className="font-body text-[#1e2025] text-base">(505)226-5556</p>
      </div>
      <div className="relative z-10 flex justify-center pb-4">
        <p className="font-body text-[#1e2025] text-sm">
          &copy;2026 by Merlin Aviation Inc.
        </p>
      </div>
    </footer>
  );
}
